export default "__VITE_ASSET__d235e4fd__"